import React, { useEffect, useRef, useState } from "react";
import { Card } from "primereact/card";
import MyButton from "../components/UI/Button";
import { useLocation, useNavigate } from "react-router-dom";
import Editor from "../components/UI/editor";
import { Toast } from "primereact/toast";
import {
  useGetOrderByTCodeQuery,
  useUpdateSetUserMutation,
} from "../store/api/orderAPI";
import { useGetRecieverByCodeQuery } from "../store/api/directory/recieverApi";
import { t } from "i18next";

export const generateTrackingCode = (prefix = "NNX") => {
  const datePart = new Date()
    .toISOString()
    .replace(/[-:TZ.]/g, "")
    .slice(4, 12);
  const randomPart = Math.floor(1000 + Math.random() * 9000);
  return `${prefix}${datePart}${randomPart}`;
};

const SetUser = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [isSaving, setIsSaving] = useState(false);
  const [userInteracted, setUserInteracted] = useState(false);

  const formDataNav = location.state?.formData || {};

  const audioSuccess = useRef(new Audio("/scun.mp3"));
  const audioError = useRef(new Audio("/error.mp3"));
  const barcodeRef = useRef(null);
  const toast = useRef(null);

  const clientCodeRef = useRef(null);
  const weightRef = useRef(null);

  const [updatSetUser] = useUpdateSetUserMutation();

  const [formData, setFormData] = useState({
    tracking_number: formDataNav?.tracking_number ?? formDataNav?.tcode ?? "",
    client_code: formDataNav?.client_code || "KG",
    gross_weight: formDataNav?.gross_weight || "",
    width: formDataNav?.width || "",
    height: formDataNav?.height || "",
    length: formDataNav?.length || "",
    stock_comment: formDataNav?.stock_comment || "",
    with_box: formDataNav?.with_box || false,
  });

  const { data: reciever = [] } = useGetRecieverByCodeQuery(formData?.client_code, {
    skip: !formData?.client_code || formData.client_code?.length < 3,
  });

  const { data: order } = useGetOrderByTCodeQuery(
    {
      tcode: formDataNav?.tracking_number ?? formDataNav?.tcode,
    },
    {
      skip: !formData?.tracking_number,
    }
  );

  useEffect(() => {
    if (order?.[0]) {
      setFormData((prev) => ({
        ...prev,
        ...order[0],
      }));
    }
  }, [order]);

  useEffect(() => {
    clientCodeRef.current?.focus();
  }, []);

  useEffect(() => {
    const handleInteraction = () => {
      setUserInteracted(true);
      window.removeEventListener("keydown", handleInteraction);
      window.removeEventListener("click", handleInteraction);
    };

    window.addEventListener("keydown", handleInteraction);
    window.addEventListener("click", handleInteraction);

    return () => {
      window.removeEventListener("keydown", handleInteraction);
      window.removeEventListener("click", handleInteraction);
    };
  }, []);

  const onBlur = (e, attr, value) => {
    setFormData((state) => ({
      ...state,
      [attr]: typeof value === "string" ? value.trim() : value,
    }));
  };

  const handleKeyDown = (e, nextRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextRef?.current) {
        nextRef.current.focus();
      } else {
        handleAddStack();
      }
    }
  };

  const volumeWeight = Number(
    (
      ((Number(formData?.width) || 0) *
        (Number(formData?.height) || 0) *
        (Number(formData?.length) || 0)) /
      6000
    ).toFixed(2)
  );

  const hasSpecialPackage =
    !!reciever?.[0]?.package_shoes || !!reciever?.[0]?.bag_package;

  const handleAddStack = async () => {
    if (isSaving) return;

    if (!reciever?.length) {
      if (userInteracted) audioError.current?.play();
      toast.current?.show({
        severity: "error",
        summary: "Клиент не найден!",
        detail: "Не удалось создать заказ",
        life: 10000,
      });
      return;
    }

    if (!formData.client_code || !formData.tracking_number || !formData.gross_weight) {
      if (userInteracted) audioError.current?.play();
      toast.current?.show({
        severity: "error",
        summary: "Не удалось создать заказ",
        detail:
          "Заполните обязательные поля: Трек номер, код клиента, вес",
        life: 10000,
      });
      return;
    }

    try {
      setIsSaving(true);

      const { data } = await updatSetUser({
        ...formData,
        reciever_guid: reciever[0]?.guid,
        v_weight:
          ((Number(formData?.width) || 0) *
            (Number(formData?.height) || 0) *
            (Number(formData?.length) || 0)) /
          6000,
      });

      if (data?.success) {
        if (userInteracted) audioSuccess.current?.play();

        toast.current?.show({
          severity: "success",
          summary: "Сохранено на складе",
          life: 10000,
        });

        setTimeout(() => {
          setIsSaving(false);
          navigate("/order-process/25");
        }, 1500);
      } else {
        if (userInteracted) audioError.current?.play();
        toast.current?.show({
          severity: "error",
          summary: "Ошибка",
          detail: "Не удалось сохранить заказ",
          life: 10000,
        });
        setIsSaving(false);
      }
    } catch (error) {
      if (userInteracted) audioError.current?.play();
      toast.current?.show({
        severity: "error",
        summary: "Ошибка",
        detail: "Произошла ошибка при сохранении",
        life: 10000,
      });
      setIsSaving(false);
    }
  };

  return (
    <>
      <div ref={barcodeRef} style={{ display: "none" }}>
        <svg id="barcode"></svg>
      </div>

      <Toast ref={toast} />

      <p style={{ paddingLeft: 12, fontSize: 18, fontWeight: 600 }}>
        {t("orders")}
      </p>

      <Card title={t("processOrder")}>
        <div className="user-sidebar">
          <div className="set_user">
            <div className="left">
              <div className="inp_button">
                <div style={{ width: "calc(100% - 140px)" }}>
                  <Editor
                    label={t("tracking_number")}
                    data={formData}
                    attr="tracking_number"
                    disabled
                  />
                </div>

                <MyButton
                  label={t("generateCode")}
                  onClick={() => {
                    setFormData((prev) => ({
                      ...prev,
                      tracking_number: generateTrackingCode(),
                    }));
                  }}
                />
              </div>

              <Editor
                refEl={clientCodeRef}
                label="Код клиента"
                data={formData}
                attr="client_code"
                onBlur={onBlur}
                onKeyDown={(e) => handleKeyDown(e, weightRef)}
              />

              <p style={{ marginTop: 8, marginBottom: 12, fontSize: 15 }}>
                {reciever.length
                  ? reciever[0]?.first_name || reciever[0]?.last_name
                    ? `${reciever[0]?.first_name ?? ""} ${reciever[0]?.last_name ?? ""}`.trim()
                    : reciever[0]?.email ?? "Не найдено"
                  : "Клиент не найден"}
              </p>

              {(formData?.with_box || hasSpecialPackage) && (
                <div
                  style={{
                    marginBottom: 16,
                    padding: 16,
                    borderRadius: 14,
                    border: "2px solid #ff4d4f",
                    background:
                      "linear-gradient(135deg, rgba(255,77,79,0.10), rgba(255,193,7,0.12))",
                    boxShadow: "0 6px 18px rgba(255,77,79,0.12)",
                  }}
                >
                  <div
                    style={{
                      fontSize: 18,
                      fontWeight: 700,
                      color: "#b00020",
                      marginBottom: 10,
                    }}
                  >
                    ⚠️ Оставить коробку
                  </div>

                  {formData?.with_box ? (
                    <div
                      style={{
                        marginBottom: 8,
                        padding: "10px 12px",
                        borderRadius: 10,
                        background: "#fff",
                        fontWeight: 700,
                        color: "#111",
                        border: "1px solid rgba(255,77,79,0.35)",
                      }}
                    >
                      📦 У заказа выбрана коробка
                    </div>
                  ) : null}

                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr",
                      gap: 8,
                    }}
                  >
                    <div
                      style={{
                        padding: "10px 12px",
                        borderRadius: 10,
                        background: reciever?.[0]?.package_shoes ? "#fff7e6" : "#f5f5f5",
                        border: reciever?.[0]?.package_shoes
                          ? "1px solid #fa8c16"
                          : "1px solid #d9d9d9",
                        fontWeight: 600,
                      }}
                    >
                      👟 Обувь:{" "}
                      <span
                        style={{
                          color: reciever?.[0]?.package_shoes ? "#d46b08" : "#666",
                          fontWeight: 700,
                        }}
                      >
                        {reciever?.[0]?.package_shoes ? "Да" : "Нет"}
                      </span>
                    </div>

                    <div
                      style={{
                        padding: "10px 12px",
                        borderRadius: 10,
                        background: reciever?.[0]?.bag_package ? "#fff1f0" : "#f5f5f5",
                        border: reciever?.[0]?.bag_package
                          ? "1px solid #ff4d4f"
                          : "1px solid #d9d9d9",
                        fontWeight: 600,
                      }}
                    >
                      👜 Сумка рюкзаки:{" "}
                      <span
                        style={{
                          color: reciever?.[0]?.bag_package ? "#cf1322" : "#666",
                          fontWeight: 700,
                        }}
                      >
                        {reciever?.[0]?.bag_package ? "Да" : "Нет"}
                      </span>
                    </div>
                  </div>
                </div>
              )}

              <Editor
                refEl={weightRef}
                label={t("weight")}
                data={formData}
                attr="gross_weight"
                onBlur={onBlur}
                onKeyDown={(e) => handleKeyDown(e, null)}
              />
            </div>

            <div className="right_block">
              <div className="volume">
                <label>{t("dimensions")}</label>

                <div className="volume_inps">
                  <Editor
                    data={formData}
                    attr="width"
                    label={t("width")}
                    type={1}
                    tabIndex={1}
                    onBlur={onBlur}
                  />
                  <Editor
                    data={formData}
                    attr="height"
                    label={t("height")}
                    type={1}
                    tabIndex={2}
                    onBlur={onBlur}
                  />
                  <Editor
                    data={formData}
                    attr="length"
                    label={t("length")}
                    type={1}
                    tabIndex={3}
                    onBlur={onBlur}
                  />
                </div>

                <div style={{ marginTop: 8, fontWeight: 600 }}>
                  Объёмный вес: {volumeWeight}
                </div>
              </div>

              <Editor
                label={t("comment")}
                row={4}
                data={formData}
                attr="stock_comment"
                onBlur={onBlur}
              />
            </div>
          </div>

          <br />

          <MyButton
            label={isSaving ? "Сохранение..." : t("addStack")}
            onClick={handleAddStack}
            disabled={isSaving}
          />

          {formData?.with_box ? (
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                fontSize: 18,
                marginTop: 12,
                fontWeight: 700,
                color: "#b00020",
              }}
            >
              <input
                type="checkbox"
                checked={!!formData?.with_box}
                readOnly
                disabled
                style={{ width: 18, height: 18, margin: "12px 0" }}
              />
              Коробка нужна
            </label>
          ) : (
            ""
          )}
        </div>
      </Card>
    </>
  );
};

export default SetUser;